import { Box, Grid } from "@mui/material";

import CustomHeading from "../../../../../components/customText/CustomHeading";
import { useNavigate } from "react-router-dom";
import TestBillingAddress from "./addresscomp/BillingAddress";
import ShowingSelectedTest from "./showSelectedTestOnCheckout/ShowingSelectedTest";
import PaymentMethodAndProceed from "./paymentmethodAndProceed/PaymentMethodAndProceed";

export default function PurchaseTestCheckout() {
  const navigate = useNavigate();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomHeading lable="Checkout" onClick={() => navigate(-1)} />
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
          }}
        >
          <Box sx={{ flexShrink: 0 }}>
            <TestBillingAddress />
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              mt: 2,
            }}
          >
            {" "}
            <ShowingSelectedTest />
          </Box>
        </Grid>

        <Grid item xs={12} sn={12} md={4}>
          <PaymentMethodAndProceed />
        </Grid>
      </Grid>
    </>
  );
}
